var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuOpenRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.297 9.6",
    enableBackground: "new 0 0 12.297 9.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.004,1.975c0.134-0.097,0.354-0.097,0.488,0l3.704,2.651 c0.134,0.097,0.134,0.253,0,0.35L8.493,7.625c-0.134,0.097-0.354,0.097-0.488,0L7.32,7.135c-0.134-0.097-0.134-0.253,0-0.35 l2.529-1.81c0.134-0.097,0.134-0.253,0-0.35L7.32,2.814c-0.134-0.096-0.134-0.253,0-0.35L8.004,1.975z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8,5.3c0,0.165-0.135,0.3-0.3,0.3H0.3C0.135,5.6,0,5.465,0,5.3 v-1C0,4.135,0.135,4,0.3,4h7.4C7.865,4,8,4.135,8,4.3V5.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4,1.3c0,0.165-0.135,0.3-0.3,0.3H0.3 C0.135,1.6,0,1.465,0,1.3v-1C0,0.135,0.135,0,0.3,0h9.8c0.165,0,0.3,0.135,0.3,0.3V1.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4,9.3c0,0.165-0.135,0.3-0.3,0.3H0.3 C0.135,9.6,0,9.465,0,9.3V8.299c0-0.165,0.135-0.3,0.3-0.3h9.8c0.165,0,0.3,0.135,0.3,0.3V9.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpenRight);
export default __webpack_public_path__ + "static/media/menu_open_right.05b9ccd19bb7f81dc0c047a58f504a8e.svg";
export { ForwardRef as ReactComponent };